module.exports = __webpack_public_path__ + "static/media/petrecere-icon.b4f921ae.svg";